import { IMoneyDto } from "../../rma-types";


export interface ICalculatorResponseDTO {
    restock: IRefundCalculatorToggleDto;
    restock_location_id?: string;
    notify_on_platform: boolean;
    auto_populate_refund_amount: boolean;
    /**
     * selected_refund_method_id and selected_refund_method_type work together,
     *
     * selected_refund_method_id: can be a real refund type or refund type + 100000 (INTEGRATION_TO_OFFER_REFUND_START),
     * that means, that some refund types may use integration like Rise.
     *
     * selected_refund_method_type: is always a real refund type defined in constants of ProductCaseOffer,
     * it is used in refund calculator to define UI behavior and available amount calculation
     * */
    selected_refund_method_id: number;
    selected_refund_method_type: REFUND_METHODS;
    is_tax_included: boolean;
    is_original_payment_captured: boolean;
    conversion_rate: number;
    payment_currency: string;
    shop_currency: string;
    restocking_location_options: IRestockingLocationOptionDto[];
    refund_method_options:IRefundMethodOptionDto[];
    prices_breakdown: IPricesBreakdownDto;
    iban_details?: IIbanDetailsDto;
    items_paid_amount: IMoneyDto[];
    net_payment: IMoneyDto[];
}

export interface IRefundCalculatorToggleDto {
    disabled: boolean;
    checked: boolean;
}

export interface IPricesBreakdownDto {
    balance: ICalculatorItemBalanceDto[];
    shipping_cost: ICalculatorShippingCostDto[];
    paid_restocking_fees?: ICalculatorFeeDto[];
    paid_return_label_fees?: ICalculatorFeeDto[];
    paid_rma_fees?: ICalculatorFeeDto[];
    paid_cancellation_fees?: ICalculatorFeeDto[];
    return_label_fee_deduction?: ICalculatorFeeDto;
    rma_fee_deduction?: ICalculatorFeeDto;
    cancellation_fee_deduction?: ICalculatorFeeDto;
}

export interface IIbanDetailsDto {
    branch_name?: string;
    comment?: string;
    first_name?: string;
    last_name?: string;
    iban_number: number;
    branch_address?: string;
}

export interface IRefundRequestDto extends ICalculatorResponseDTO, ICalculatorRequestDTO{
    refund_amount: IMoneyDto;
}

export interface ICalculatorItemBalanceDto extends ICalculatorLineData {
    product_case_id: number;
    is_rejected?: boolean;
}

export interface ICalculatorFeeDto extends ICalculatorLineData {
    rma_id: number;
}

export interface ICalculatorShippingCostDto extends ICalculatorLineData {
    order_name: string;
    is_hidden?: boolean;
}

export interface ICalculatorLineData {
    amount: IMoneyDto[];
    tax: IMoneyDto[];
    is_selected: boolean;
    available_virtual_amount: IAvailableVirtualAmountDto[];
}

export interface IAvailableVirtualAmountDto {
    refund_method_id: REFUND_METHODS;
    amount: IMoneyDto[];
}

export interface ICalculatorRequestDTO {
    rma_id: number;
    items: {
        product_case_id: number;
    }[];
};

export interface IRefundMethodOptionDto {
    id: number;
    refund_type: number;
    label: string; //Refun To Payment Method for instance
    show_taxes: boolean; //False only for credits
}

interface IRestockingLocationOptionDto {
    id: number|string; // there is special case for fulfillment location
    label: string;
}

export enum REFUND_METHODS {
    PAYMENT_METHOD = 0,
    STORE_CREDITS = 1,
    BANK_REFUND = 2,
    GIFT_CARD = 3,
    PLATFORM_STORE_CREDITS = 4,
}

export enum REFUND_CALCULATOR_CATEGORY_TRANSLATION_KEYS {
    BALANCE = "BALANCE",
    PAID_SHIPPING_COST = "PAID_SHIPPING_COST",
    PAID_RESTOCKING_FEE = "PAID_RESTOCKING_FEE",
    PAID_RETURN_FEE = "PAID_RETURN_FEE",
    PAID_RETURN_LABEL_FEE = "PAID_RETURN_LABEL_FEE",
    PAID_CANCELLATION_FEE = "PAID_CANCELLATION_FEE",
    RETURN_LABEL_FEE_DEDUCTION = "RETURN_LABEL_FEE_DEDUCTION",
    RETURN_FEE_DEDUCTION = "RETURN_FEE_DEDUCTION",
    CANCELLATION_FEE_DEDUCTION = "CANCELLATION_FEE_DEDUCTION",
}